import { SET_TEACHER_APPLICATIONS, SET_LOADING } from '../Actions/types';

const initialState = {
  applications: [],
  loading: false
};

const teacherManagerReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LOADING:
      return { ...state, loading: true };

    case SET_TEACHER_APPLICATIONS:
      return { ...state, applications: action.payload, loading: false };

    default:
      return state;
  }
};

export default teacherManagerReducer;
